import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2, AlertCircle, CheckCircle2 } from "lucide-react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [f, setF] = useState({ new_password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-4">
        <Card className="w-full max-w-md p-8 shadow-2xl">
          <div className="text-red-700 flex items-center gap-2"><AlertCircle className="w-5 h-5" /> Link non valido.</div>
          <Link to="/login" className="text-sm text-blue-700 hover:underline mt-4 inline-block">Torna al login</Link>
        </Card>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (f.new_password.length < 8) { setErr("La password deve avere almeno 8 caratteri"); return; }
    if (f.new_password !== f.confirm) { setErr("Le due password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: f.new_password });
      setDone(true);
      setTimeout(() => nav("/login", { replace: true }), 2500);
    } catch (e) {
      setErr(e.response?.data?.detail || "Errore durante il reset");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="emmepi-logo-mark">M</div>
          <div>
            <div className="text-lg font-extrabold text-slate-900">emmepigroup</div>
            <div className="text-xs text-slate-500 uppercase tracking-wider">Reimposta password</div>
          </div>
        </div>
        {done ? (
          <div className="text-green-700 bg-green-50 border border-green-200 rounded p-3 flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5" /> Password aggiornata. Ti reindirizziamo al login…
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h1 className="text-2xl font-bold text-slate-900 mb-1">Imposta la nuova password</h1>
            <p className="text-sm text-slate-600">Scegli una password di almeno 8 caratteri.</p>
            <div>
              <Label>Nuova password</Label>
              <Input type="password" required autoFocus minLength={8} value={f.new_password} onChange={e => setF({ ...f, new_password: e.target.value })} data-testid="reset-new" />
            </div>
            <div>
              <Label>Conferma password</Label>
              <Input type="password" required minLength={8} value={f.confirm} onChange={e => setF({ ...f, confirm: e.target.value })} data-testid="reset-confirm" />
            </div>
            {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2 flex items-center gap-2"><AlertCircle className="w-4 h-4" /> {err}</div>}
            <Button type="submit" disabled={busy} className="w-full bg-blue-700 hover:bg-blue-800" data-testid="reset-submit">
              {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />} Salva nuova password
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
